import React from 'react';
import { useSelector } from 'react-redux';

const ResultsCount = () => {
  const { data, journeyData, contentType } = useSelector(
    reduxState => reduxState,
  );

  return (
    <div>
      {contentType === 0 ? data.length : journeyData.length}{' '}
      {t('contents.advanced_search.results')}{' '}
      {t('contents.advanced_search.found')}
    </div>
  );
};

export default ResultsCount;
